<template>
  <div class="form container">
    <div>
      <div class="text-center">
        <img
          class="mb-4 mx-auto"
          src="../assets/logowhite.svg"
          alt="logo"
          width="320"
        />
        <h1 class="fw mb-3">First, enter your email.</h1>
        <h5>It is recommended to use your work email address.</h5>
      </div>
      <RegisterForm formType="register" @submit="handleRegister" />
      <hr class="my-4" />
      <OAuthButtons />
      <small class="text-body-secondary"
        ><span class="text">Already using COPLAN? </span>
        <router-link to="/login" class="link">Sign in your account</router-link>
      </small>
    </div>
    <BasicAlert :visible="showAlert" message="Please Check Your Form!" />
  </div>
</template>

<script>
import OAuthButtons from "@/components/auth/OAuthButtons.vue";
import RegisterForm from "@/components/auth/authForm.vue";
import "@/assets/styles/authStyles.css";
import BasicAlert from "@/components/global/BasicAlert.vue"; // 确保您已创建此组件

export default {
  components: {
    OAuthButtons,
    RegisterForm,
    BasicAlert,
  },
  data() {
    return {
      showAlert: false,
    };
  },
  methods: {
    handleRegister(formData) {
      // 这里可以添加实际的注册逻辑，比如验证输入和发送请求到后端
      if (!formData.username || !formData.password || !formData.email) {
        this.showAlert = true; // 如果验证失败，显示警告
        setTimeout(() => {
          this.showAlert = false; // 3秒后隐藏警告
        }, 3000);
        return; // 阻止表单提交
      }
      console.log("Registering with:", formData);
      // 假设注册成功
      this.$router.push("/"); // 导航到初始设置页面
    },
  },
};
</script>

<style scoped>
::v-deep .form container {
  position: absolute;
  top: 0px;
  left: 0px;
}
</style>
